import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

export const SnackbarTemplateMaterialModules = [MatButtonModule, MatIconModule];
